import { ISphereXgConfig, IWebShareConf, WebshareAuthType, WebshareLoadImageMethod } from "./point-cloud.interface";

export interface ICompanyInfo {
    id: number;
    name: string;
    intositeVersion: string;
    userName: string;
    ssoLogin: boolean;
    ssoEnable: boolean;
    webshareAuthType: WebshareAuthType;
    intositeLoginMethod: IntositeLoginMethod;
    webShareConfs: IWebShareConf[];
    sphereXGConfs: ISphereXgConfig[];
    webshareLoadImageMethod: WebshareLoadImageMethod;
    dataPrivacyConsentInfo: IDataPrivacyConsentInfo;
    soldToId: string;
    ocx?: boolean;
}

export interface ISessionMetaData {
    loginThrough: LoginThrough
    ssoLogin?: boolean;
    ssoEnable?: boolean;
    intositeLoginMethod?: IntositeLoginMethod;
    company?: string;
    ocx?: boolean
}

export enum LoginThrough {
    Main = '',
    Tour = 'Tour'
}

export enum IntositeLoginMethod {
    Manual = 'Manual',
    Enterprise = 'Enterprise',
    SSOIDP = 'SSOIDP',
    Sphere = 'Sphere'
}

export enum DataPrivacyType {
    DPE = 'DPE',
    PEP = 'PEP'
}

export interface IDataPrivacyConsentInfo {
    showDataPrivacyPepConsent: boolean;
    dpe: string;
    pep: string;
}